import { updateTooltip } from "api";
import { createContext, useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";

const videoData = [
  // {
  //   path: "/dashboard/ai-assistant",
  //   desktop_video: "https://player.vimeo.com/video/947319158",
  //   type: "tutorial_video_nara",
  //   modal_type: "tutorial_video_nara_modal",
  // },
  // {
  //   path: "/dashboard/posts/calendar-view?post_action=create_post",
  //   desktop_video: "https://player.vimeo.com/video/947314013",
  //   type: "tutorial_video_create_post",
  //   modal_type: "tutorial_video_create_post_modal",
  // },
  // {
  //   path: "/dashboard/drafts/create",
  //   desktop_video: "https://player.vimeo.com/video/947316693",
  //   type: "tutorial_video_draft",
  //   modal_type: "tutorial_video_draft_modal",
  // },
  // {
  //   path: "/dashboard/calendar",
  //   desktop_video: "https://player.vimeo.com/video/947324852",
  //   type: "tutorial_video_calender",
  //   modal_type: "tutorial_video_calender_modal",
  // },
  // {
  //   path: "/dashboard/brands/create",
  //   desktop_video: "https://player.vimeo.com/video/947330088",
  //   type: "tutorial_video_create_brand",
  //   modal_type: "tutorial_video_create_brand_modal",
  // },
  // {
  //   path: "/dashboard/team-members",
  //   desktop_video: "https://player.vimeo.com/video/947332544",
  //   type: "tutorial_video_team_members",
  //   modal_type: "tutorial_video_team_members_modal",
  // },
  // {
  //   path: "/dashboard/comments/",
  //   desktop_video: "https://player.vimeo.com/video/947335255",
  //   type: "tutorial_video_comments",
  //   modal_type: "tutorial_video_comments_modal",
  // },
  // {
  //   path: "/dashboard/direct-messages/",
  //   desktop_video: "https://player.vimeo.com/video/947334010",
  //   type: "tutorial_video_dms",
  //   modal_type: "tutorial_video_dms_modal",
  // },
  {
    path: "/dashboard",
    desktop_video: "https://player.vimeo.com/video/947334010",
    type: "tutorial_video_dms",
    modal_type: "tutorials_drawer",
  },
  // {
  //   path: "/dashboard/analytics",
  //   desktop_video: "https://vimeo.com/947316693?share=copy",
  //   type: "tutorial_video_analytics",
  // },
];

export const TutorialContext = createContext(null);

const initState = {
  tutorial_video_create_post: true,
  tutorial_video_create_post_modal: false,
  tutorial_video_draft: true,
  tutorial_video_draft_modal: false,
  tutorial_video_nara: true,
  tutorial_video_nara_modal: false,
  tutorial_video_calender: true,
  tutorial_video_calender_modal: false,
  tutorial_video_create_brand: true,
  tutorial_video_create_brand_false: true,
  tutorial_video_team_members: true,
  tutorial_video_team_members_modal: false,
  tutorial_video_comments: true,
  tutorial_video_comments_false: false,
  tutorial_video_dms: true,
  tutorial_video_dms_modal: false,
  tutorial_video_analytics: true,
  tutorial_video_analytics_modal: false,
  tutorials_drawer: false,
  tutorials_drawer_modal: false,
};

const TutorialContextProvider = ({ children, guided_tours }) => {
  const { pathname } = useLocation();
  const [hasSeenVideo, setHasSeenVideo] = useState(initState);

  const video = videoData.find((item) => {
    if (pathname === item.path) {
      return true;
    }

    if (item.path !== "/dashboard") {
      return pathname.includes(item.path);
    }

    return (
      pathname.startsWith("/dashboard") &&
      !videoData.some(
        (v) => v.path !== "/dashboard" && pathname.includes(v.path)
      )
    );
  });

  const handleWatchVideo = () => {
    if (!video) return;

    setHasSeenVideo({
      ...initState,
      [video?.modal_type]: true,
    });
  };

  const handleCloseVideoModal = () => {
    setHasSeenVideo((prevState) => ({
      ...prevState,
      [video?.modal_type]: false,
    }));
  };

  const handleCloseModal = () => {
    setHasSeenVideo({ ...initState });
    if (!guided_tours[video?.type]) {
      updateTooltip({ ...guided_tours, [video?.type]: true });
    }
  };

  const handleShowMe = () => {
    if (!guided_tours[video?.type]) {
      updateTooltip({ ...guided_tours, [video?.type]: true });
    }
    setHasSeenVideo((prevState) => ({
      ...prevState,
      [video?.modal_type]: true,
    }));
  };

  useEffect(() => {
    if (video) {
      setHasSeenVideo((prevState) => ({
        ...prevState,
        [video?.type]: guided_tours[video?.type] ?? true,
      }));
    }
  }, [guided_tours, video]);

  return (
    <TutorialContext.Provider
      value={{
        hasSeenVideo,
        setHasSeenVideo,
        video,
        handleWatchVideo,
        initState,
        handleCloseModal,
        handleShowMe,
        handleCloseVideoModal,
      }}
    >
      {children}
    </TutorialContext.Provider>
  );
};

const mapStateToProps = (state) => {
  return {
    guided_tours: state.guided_tours,
  };
};

export default connect(mapStateToProps)(TutorialContextProvider);
